import dayjs from 'dayjs';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      timezone: 'timezone/choosenTimezone',
    }),
    formattedNewSlotStartDate() {
      const utcDate = dayjs.tz(this.notification.data.new_slot.start_date, 'UTC');
      return dayjs(utcDate).tz(this.timezone)
        .format('DD/MM/YYYY HH:mm');
    },
    formattedOldSlotStartDate() {
      const utcDate = dayjs.tz(this.notification.data.old_slot.start_date, 'UTC');
      return dayjs(utcDate).tz(this.timezone)
        .format('DD/MM/YYYY HH:mm');
    },
  },
};
